import { BrowserRouter, Routes, Route } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import AuthChecker from "./components/AuthChecker";
import { ToastContainer } from "react-toastify";
import { useUser } from "./hooks/useUser";

//Page

//Login
import Login from "./Pages/Authentication/Login";
//Singup
//Forgot password
import Forgot from "./Pages/Authentication/Forgot";
//Otp
import Otp from "./Pages/Authentication/Otp";

//Dashbord
import Dashbord from "./layouts/dashbord";

//Error Page
import ErrorPage from "./Pages/Error";

//Home
import Home from "./Pages/Home/index";
import EmpDashboard from "./Pages/Home/empDashboard";
import VenDashboard from "./Pages/Home/venDashboard";

//Products
import Products from "./Pages/Products/index";
import ProductsAddOrUpdate from "./Pages/Products/addorupdate";
import AdminProductsAddOrUpdate from "./Pages/Products/adminaddorupdate";
import Details from "./Pages/Products/details";
import ListOfProducts from "./Pages/Products/listofproducts.jsx";
import ProductCategoryAdd from "./Pages/Products/ProductCategoryAdd";
import VendorProductDetail from "./Pages/Products/VendorProductDetail";

//Stock
import Stock from "./Pages/Stock/index";
import StockAddorUpdate from "./Pages/Stock/addorupdate";
import StockDetails from "./Pages/Stock/details";

//Setting
import AdminSetting from "./Pages/Setting/adminsetting";
import AdminProfileSettings from "./Pages/Setting/AdminProfileSettings";
import EmployeeProfileSettings from "./Pages/Employee/EmployeeProfileSettings";
import DriverProfileSettings from "./Pages/Driver/DriverProfileSettings";
import VendorProfileSettings from "./Pages/Vendors/VendorProfileSettings";

//Employee
import Employee from "./Pages/Employee/index";
import EmployeeAddorUpdate from "./Pages/Employee/addorupdate";
import EmployeeDetails from "./Pages/Employee/details";
import EmployeeLoginDetails from "./Pages/Employee/EmployeeLoginDetails";

//Driver
import Driver from "./Pages/Driver/index";
import DriverLogin from "./Pages/Driver/DriverLogin";
import DriverDashboard from "./Pages/Driver/DriverDashboard";
import DriverTestConnection from "./Pages/Driver/DriverTestConnection";
//Driver add or update
import DriverAddorUpdate from "./Pages/Driver/addorupdate";
import DriverDetails from "./Pages/Driver/details";

// Vendor
import Vendor from "./Pages/Vendors/index";
import VendorAddOrUpdate from "./Pages/Vendors/addorupdate";
import VendorDetails from "./Pages/Vendors/details";
import VendorOrders from "./Pages/OrdersDelivery/VendorOrders";
import VendorOrderDetails from "./Pages/OrdersDelivery/VendorOrderDetails";

//Order & delivery
import OrderDelivery from "./Pages/OrdersDelivery/index";
import Review from "./Pages/OrdersDelivery/review";
import VendorReview from "./Pages/OrdersDelivery/VendorReview";
import ReAssignDrivers from "./Pages/OrdersDelivery/ReAssignDrivers";
import Delivery from "./Pages/OrdersDelivery/delivery";
import OrderDeatils from "./Pages/OrdersDelivery/orderdeatils";
import AssignOrder from "./Pages/OrdersDelivery/AssignOrder";
import DriverAssignmentView from "./Pages/OrdersDelivery/DriverAssignmentView";

//Accounts
import CollectionCash from "./Pages/Accounts/CollectionCash";
import DriverDepositCash from "./Pages/Accounts/DriverDepositCash";
import VendorDepositCash from "./Pages/Accounts/VendorDepositCash";
import AddCollectionCash from "./Pages/Accounts/AddCollectionCash";
import AddDriverDepositCash from "./Pages/Accounts/AddDriverDepositCash";
import AddVendorDepositCash from "./Pages/Accounts/AddVendorDepositCash";
import AddDriverExpense from "./Pages/Accounts/AddDriverExpense";
import AddVendorExpense from "./Pages/Accounts/AddVendorExpense";
import AddVendorExpenseVendor from "./Pages/Accounts/AddVendorExpenseVendor";

//Customer
import CustomerList from "./Pages/customer/index.jsx";
import CustomerDetails from "./Pages/customer/details.jsx";
import ContactMessages from "./Pages/customer/contact_messages.jsx";

//Offers
import Offer from "./Pages/Offers/index.jsx";
import AddOffer from "./Pages/Offers/addoffer.jsx";
// import AddOffers from './Pages/Offers/OffersPage.jsx'
// import OfferList from './Pages/Offers/offerlist.jsx';

//Vendor Applications
import VendorApplications from "./Pages/VendorApplications.jsx";

// main.js or index.js
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import ErrorBoundary from "./components/ErrorBoundary.jsx";
import ResetPassword from "./Pages/Authentication/ResetPassword.jsx";

import DriverCommission from "./Pages/Accounts/DriverCommission.jsx";

import DriverCommissionRequests from "./Pages/Accounts/DriverCommissionRequests.jsx";
import { useEffect, useState } from "react";

// Linear Icon css

//scrollbar simplebar

//remixicon css

/* App css */

//Plugins css
// import './assets/css/vendors/scrollbar.css';

// fortawesome

// slick slider js

// Menu IDs
// 0 => Dashboard
// 1 => Product & Stock
// 2 => Employee
// 3 => Drivers
// 4 => Order & delivery
// 5 => Settings

// Component to handle user preloading inside Router context
function AppContent() {
  useUser(); // Preload user data for fast protected routes

  const [toastTheme, setToastTheme] = useState(() => {
    const saved = localStorage.getItem("darkTheme");
    return saved === "true" ? "dark" : "light";
  });

  useEffect(() => {
    const onDark = (e) => {
      if (e.detail && e.detail.theme) {
        setToastTheme(e.detail.theme);
      } else {
        const saved = localStorage.getItem("darkTheme");
        setToastTheme(saved === "true" ? "dark" : "light");
      }
    };

    window.addEventListener("onToastDark", onDark);
    return () => window.removeEventListener("onToastDark", onDark);
  }, []);

  return (
    <AuthChecker> 
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        theme={toastTheme}
      />
      <Routes>
        {/* Authentication */}
        <Route path="/" element={<Login />} />
        <Route path="/forgot" element={<Forgot />} />
        <Route path="/otp" element={<Otp />} />

        {/* Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Dashbord MenuId={0} page={<Home />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee-dashboard"
          element={
            <ProtectedRoute allowedRoles={["employee"]}>
              <Dashbord MenuId={0} page={<EmpDashboard />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendor-dashboard"
          element={
            <ProtectedRoute allowedRoles={["vendor"]}>
              <Dashbord MenuId={0} page={<VenDashboard />} />
            </ProtectedRoute>
          }
        />

        <Route path="/reset-password" element={<ResetPassword />} />

        {/* For admin can view way of vendor */}
        <Route
          path="/vendor/:menuid"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord page={<Vendor />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendor"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Dashbord page={<Vendor />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendoraddorupdate"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord page={<VendorAddOrUpdate />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendoraddorupdate/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord page={<VendorAddOrUpdate />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendordetails/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord page={<VendorDetails />} />
            </ProtectedRoute>
          }
        />

        {/* Products */}
        <Route
          path="/product"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={1} page={<Products />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/productsaddorupdate"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={1} page={<ProductsAddOrUpdate />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/productsaddorupdate/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={1} page={<ProductsAddOrUpdate />} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/adminproductsaddorupdate"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={1} page={<AdminProductsAddOrUpdate />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/adminproductsaddorupdate/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={1} page={<AdminProductsAddOrUpdate />} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/productsdetails/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={1} page={<Details />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/listofproducts"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={1} page={<ListOfProducts />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/product-category-add"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={1} page={<ProductCategoryAdd />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendor-product/:vendor_product_id"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={1} page={<VendorProductDetail />} />
            </ProtectedRoute>
          }
        />

        {/* Stock */}
        <Route
          path="/stock/:productname"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={1} page={<Stock />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stockdetails"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={1} page={<StockDetails />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stockaddorupdate/:vendor_product_id"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={1} page={<StockAddorUpdate />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/stockaddorupdate/"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={1} page={<StockAddorUpdate />} />
            </ProtectedRoute>
          }
        />

        {/* Employee */}
        <Route
          path="/employee"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Dashbord MenuId={2} page={<Employee />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employeeaddorupdate"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Dashbord MenuId={2} page={<EmployeeAddorUpdate />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employeeaddorupdate/:id"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Dashbord MenuId={2} page={<EmployeeAddorUpdate />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employeedetails/:id"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Dashbord MenuId={2} page={<EmployeeDetails />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee-login-details"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Dashbord MenuId={2} page={<EmployeeLoginDetails />} />
            </ProtectedRoute>
          }
        />

        {/* Driver */}
        <Route
          path="/driver"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={3} page={<Driver />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/driveraddorupdate"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={3} page={<DriverAddorUpdate />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/driveraddorupdate/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={3} page={<DriverAddorUpdate />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/driverdetails/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={3} page={<DriverDetails />} />
            </ProtectedRoute>
          }
        />

        {/* Driver Testing Routes - Separate from main app */}
        <Route
          path="/driver-test/connection"
          element={<DriverTestConnection />}
        />
        <Route path="/driver-test/login" element={<DriverLogin />} />
        <Route path="/driver-test/dashboard" element={<DriverDashboard />} />

        {/* Customer */}
        <Route
          path="/customer"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={4} page={<CustomerList />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/customerdetails/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={4} page={<CustomerDetails />} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/ContactMessages"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={4} page={<ContactMessages />} />
            </ProtectedRoute>
          }
        />

        {/* Vendor Applications */}
        <Route
          path="/vendor-applications"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={4} page={<VendorApplications />} />
            </ProtectedRoute>
          }
        />

        {/* Order & delivery */}
        <Route
          path="/order"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={4} page={<OrderDelivery />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/review"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={4} page={<Review />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/VendorReview"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={4} page={<VendorReview />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/ReAssignDrivers"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={4} page={<ReAssignDrivers />} />
            </ProtectedRoute>
          }
        />
        {/* <Route path="/delivery" element={<ProtectedRoute allowedRoles={['admin', 'vendor','employee']}><Dashbord MenuId={4} page={<Delivery />} /></ProtectedRoute>} /> */}
        <Route
          path="/orderdeatils/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={4} page={<OrderDeatils />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/assign-order"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={4} page={<AssignOrder />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/driver-assignments"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={4} page={<DriverAssignmentView />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/orders"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={4} page={<VendorOrders />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendorOrderDetails/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={4} page={<VendorOrderDetails />} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/collectioncash"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={5} page={<CollectionCash />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/driverdepositcash"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={5} page={<DriverDepositCash />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendordepositcash"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={5} page={<VendorDepositCash />} />
            </ProtectedRoute>
          }
        />
        {/* <Route
          path="/accounts/add-collection-cash"
          element={
            <ProtectedRoute allowedRoles={["admin",'employee']}>
              <Dashbord MenuId={5} page={<AddCollectionCash />} />
            </ProtectedRoute>
          }
        /> */}
        <Route
          path="/accounts/add-driver-deposit-cash"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={5} page={<AddDriverDepositCash />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts/add-vendor-deposit-cash"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={5} page={<AddVendorDepositCash />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts/edit-driver-deposit-cash/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={5} page={<AddDriverDepositCash />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts/edit-vendor-deposit-cash/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={5} page={<AddVendorDepositCash />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts/driver-deposit-cash"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={5} page={<DriverDepositCash />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts/add-driver-expense"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={5} page={<AddDriverExpense />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts/add-vendor-expense"
          element={
            <ProtectedRoute allowedRoles={["admin", "vendor", "employee"]}>
              <Dashbord MenuId={5} page={<AddVendorExpense />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts/edit-collection-cash/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={5} page={<AddCollectionCash />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts/add-vendor-expense-vendor"
          element={
            <ProtectedRoute allowedRoles={["vendor"]}>
              <Dashbord MenuId={5} page={<AddVendorExpenseVendor />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounts/edit-vendor-expense/:id"
          element={
            <ProtectedRoute allowedRoles={["vendor"]}>
              <Dashbord MenuId={5} page={<AddVendorExpenseVendor />} />
            </ProtectedRoute>
          }
        />

        {/* Offers */}
        <Route
          path="/offers"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={6} page={<Offer />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/addoffers/:id"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={6} page={<AddOffer />} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/addoffers"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={6} page={<AddOffer />} />
            </ProtectedRoute>
          }
        />

        {/* Setting */}
        <Route
          path="/adminsetting"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Dashbord MenuId={6} page={<AdminSetting />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin-profile-settings"
          element={
            <ProtectedRoute allowedRoles={["admin"]}>
              <Dashbord MenuId={6} page={<AdminProfileSettings />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/employee-profile-settings"
          element={
            <ProtectedRoute allowedRoles={["employee"]}>
              <Dashbord MenuId={6} page={<EmployeeProfileSettings />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/driver-profile-settings"
          element={
            <ProtectedRoute allowedRoles={["driver"]}>
              <Dashbord MenuId={6} page={<DriverProfileSettings />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/vendor-profile-settings"
          element={
            <ProtectedRoute allowedRoles={["vendor"]}>
              <Dashbord MenuId={6} page={<VendorProfileSettings />} />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/driver-commission"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={5} page={<DriverCommission />} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/admin/driver-commission-requests/:driverId"
          element={
            <ProtectedRoute allowedRoles={["admin", "employee"]}>
              <Dashbord MenuId={5} page={<DriverCommissionRequests />} />
            </ProtectedRoute>
          }
        />

        {/* Unauthorized and Catch-all */}
        <Route path="/unauthorized" element={<h1>Unauthorized</h1>} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </>
      </AuthChecker>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </ErrorBoundary>
  );
}

export default App;
